export const getSchemaInSourceMetricSchema = 'getSchemaInSourceMetricSchema';
export const getTablesInSourceMetricSchema = 'getTablesInSourceMetricSchema';
export const getColumnsForTablesInSourceMetricSchema =
  'getColumnsForTablesInSourceMetricSchema';
